<template>
  <HistoryTabTemplate
    :items="items"
    :loading="loading">
    <CommentCard
      v-for="(item, itemIndex) in items"
      :key="`org-comment-${itemIndex}`"
      :data-qa="`org-comment-${itemIndex}`"
      :item="item"
      :text-button="item.needBadge ? $t('Common.Answer') : null"
      @openChat="val => $emit('openChat', val)"/>
  </HistoryTabTemplate>
</template>
<script>
import CommentCard from 'components/common/blocks/comments/CommentCard.vue'
import HistoryTabTemplate from 'components/tenders/tender page/HistoryTabTemplate.vue'
/**
 * Вопросы участников в панели истории
 */
export default {
  name: 'commentHistory',
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
  },
  components: {
    CommentCard,
    HistoryTabTemplate
  }
}
</script>
